import { render, staticRenderFns } from "./AccessUsers.vue?vue&type=template&id=229bebce"
import script from "./AccessUsers.vue?vue&type=script&lang=js"
export * from "./AccessUsers.vue?vue&type=script&lang=js"
import style0 from "./AccessUsers.vue?vue&type=style&index=0&id=229bebce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports